import { render, staticRenderFns } from "./InstanceTopBarTabsSkeleton.vue?vue&type=template&id=2ea9b6d2&scoped=true"
import script from "./InstanceTopBarTabsSkeleton.vue?vue&type=script&lang=js"
export * from "./InstanceTopBarTabsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InstanceTopBarTabsSkeleton.vue?vue&type=style&index=0&id=2ea9b6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9b6d2",
  null
  
)

export default component.exports